import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._inject()
  }

  _inject() {
    const isLight = document.documentElement.classList.contains("light")

    // Hearth palette — match CSS variable values for each theme
    const overlayBg  = isLight ? "rgba(248,245,240,0.80)" : "rgba(13,12,10,0.80)"
    const circleFill = isLight ? "#ffffff"  : "#1e1b18"   // hearth-700
    const ringColor  = isLight ? "#f5a623"  : "#fbc95a"   // warm-amber-500 / warm-amber-400

    const overlay = document.createElement("div")
    overlay.style.cssText = `
      position: fixed; inset: 0; z-index: 9999;
      display: flex; align-items: center; justify-content: center;
      background: ${overlayBg};
      backdrop-filter: blur(2px);
      animation: celebration-fade-in 0.2s ease forwards;
    `

    overlay.innerHTML = `
      <style>
        @keyframes celebration-fade-in {
          from { opacity: 0 } to { opacity: 1 }
        }
        @keyframes celebration-fade-out {
          from { opacity: 1 } to { opacity: 0 }
        }
        @keyframes circle-pop {
          0%   { transform: scale(0.6); opacity: 0 }
          60%  { transform: scale(1.08) }
          100% { transform: scale(1); opacity: 1 }
        }
        @keyframes check-draw {
          to { stroke-dashoffset: 0 }
        }
        .celebration-circle {
          animation: circle-pop 0.4s cubic-bezier(0.34,1.56,0.64,1) 0.1s both;
        }
        .celebration-check {
          stroke-dasharray: 80;
          stroke-dashoffset: 80;
          animation: check-draw 0.4s ease-out 0.45s forwards;
        }
      </style>
      <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="celebration-circle" cx="70" cy="70" r="62" fill="${circleFill}" stroke="${ringColor}" stroke-width="4"/>
        <polyline
          class="celebration-check"
          points="40,72 60,92 100,50"
          stroke="${ringColor}"
          stroke-width="8"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      </svg>
    `

    document.body.appendChild(overlay)

    // Fade out and remove after the animation settles
    setTimeout(() => {
      overlay.style.animation = "celebration-fade-out 0.4s ease forwards"
      overlay.addEventListener("animationend", () => overlay.remove(), { once: true })
    }, 1400)
  }
}
